<template>
<div>

<v-dialog max-width="600" min-width="600" v-model="settings.visible" :fullscreen="$vuetify.breakpoint.xsOnly" transition="v-fade-transition" hide-details :hide-overlay="false" :retain-focus="false" scrollable persistent>
<v-card style="width:100%" ref="dialogDOM">

    <v-card-title  class="pa-0" style="flex-grow:0">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">{{settings.title || 'Select'}}</v-toolbar-title>
            <v-spacer/>
            <slot name="header"></slot>
        </v-toolbar>
    </v-card-title>
    
    
   <v-card-text style="padding:5px;flex-grow:1;display:flex" :style="bodyStyle">
       
        <div style="flex-grow:1;overflow-y:scroll;height:100%">
            <slot></slot>
        </div>
        <div>
            <slot name="sidebar"></slot>
        </div>
   </v-card-text>

    <v-divider/> 
    <v-card-actions style="flex-grow:0;padding:10px">
            <div>
                <slot name="footer"></slot>
            </div>
            <v-spacer/>
            <template v-if="!settings.closeOnly">       
                <v-btn text @click.native="cancel">{{settings.cancelLabel || 'Cancel'}}</v-btn>
                <v-btn text @click.native="save" :disabled="disabled">{{settings.saveLabel || 'Save'}}</v-btn>                
            </template>
            <v-btn v-if="settings.closeOnly" text @click.native="close">Close</v-btn>
    </v-card-actions>

    
</v-card> 
</v-dialog>

</div>
</template>

<script>
import Utilities from '../helpers/Utilities'
export default {

props:{
    settings: Object,
    //visible, cancelLabel, saveLabel, closeOnly

    saveOnEnter: Boolean,
    disabled: {
        type: Boolean,
        default: false
    }
},

components:{

},

data() {
    return {

    }
},

computed: {

    dialogVisible() {
        return this.settings.visible
    },

    dialogHeight() {
        if(this.$vuetify.breakpoint.xsOnly)
            return '100%'
        else {
            if(this.settings.height)
            return 
                this.settings.height
            return '500px'
        }
           
    },  
    
    bodyStyle() {
        return {
            'max-height': this.$vuetify.breakpoint.xsOnly ? '100%' : '400px'
        }
    }
},

methods: {

    save() {
        this.$emit('save')
        this.settings.visible = false
    },
    
    cancel() {
        this.$emit('cancel')
        this.settings.visible = false
    },

    close() {
        this.$emit('close')
        this.settings.visible = false
    },

    enterPressed() {
        if(this.saveOnEnter)
            this.save()
    },

    focusFirstElement() {
        setTimeout( () => {
            if(Utilities.isMobile())
                return
            let el = this.$refs.dialogDOM.$el.querySelector("input")
            if(el)
                el.focus()
        },500)
    }


},

watch: {
    'settings.visible': {
        handler: function (visible) {
            if (visible) {
                this.focusFirstElement()
                this.$emit('show')
            } else
                this.$emit('hide')
        },
        immediate: true,
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// DialogBox.vue?887f182c